import React from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'

const Experience = () => {
  return (
    <section id="experience">
      <h5>What Skills I Have</h5>
      <h2>My Experience</h2>

      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Frontend Technologies</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon'/>
              <div>
                <h4>HTML</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon'/>
              <div>
                <h4>CSS</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Tailwind</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>

            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon'/>
              <div>
                <h4>JavaScript</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>

            {/* <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon'/>
              <div>
                <h4>Bootstrap</h4>
                <small className='text-light'>Basic</small>
              </div>
            </article> */}

            {/* <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon'/>
              <h4>Taiwind</h4>
              <small className='text-light'>Experienced</small>
            </article> */}

            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon'/>
              <div>
                <h4>ReactJs</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
          </div>
        </div>
        {/* ------------------------------------------------- */}
        <div className="Programming ">
          <h3>Backend Technologies</h3>
          <div className="experience__content">
              <article className="experience__details">
                <BsPatchCheckFill className='experience__details-icon'/>
                <div>
                  <h4>Spring Boot</h4>
                  <small className='text-light'>Experienced</small>
                </div>
              </article>

              <article className="experience__details">
                <BsPatchCheckFill className='experience__details-icon'/>
                <div>
                  <h4>PostgreSQL</h4>
                  <small className='text-light'>Experienced</small>
                </div>
              </article>

              <article className="experience__details">
                <BsPatchCheckFill className='experience__details-icon'/>
                <div>
                  <h4>NodeJS</h4>
                  <small className='text-light'>Intermediate</small>
                </div>
              </article>

              <article className="experience__details">
                <BsPatchCheckFill className='experience__details-icon'/>
                <div>
                  <h4>MongoDB</h4>
                  <small className='text-light'>Beginner</small>
                </div>
              </article>

              {/* <article className="experience__details">
                <BsPatchCheckFill/>
                <h4>Taiwind</h4>
                <small className='text-light'>Experienced</small>
              </article> */}

              {/* <article className="experience__details">
                <BsPatchCheckFill className='experience__details-icon'/>
                <div>
                  <h4>Node JS</h4>
                  <small className='text-light'>Beginner</small>
                </div>
              </article> */}
            </div>
            
          </div>

          {/* ------------------------------------------------- */}
          <div className="experience__programming">
            <h3>Programming Languages</h3>
            <div className="experience__content">
                <article className="experience__details">
                  <BsPatchCheckFill className='experience__details-icon'/>
                  <div>
                    <h4>Java</h4>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>

                <article className="experience__details">
                  <BsPatchCheckFill className='experience__details-icon'/>
                  <div>
                    <h4>C++</h4>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>

                <article className="experience__details">
                  <BsPatchCheckFill className='experience__details-icon'/>
                  <div>
                    <h4>C</h4>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>

                <article className="experience__details">
                  <BsPatchCheckFill className='experience__details-icon'/>
                  <div>
                    <h4>Python</h4>
                    <small className='text-light'>Intermediate</small>
                  </div>
                </article>

                

                {/* <article className="experience__details">
                  <BsPatchCheckFill className='experience__details-icon'/>
                  <div>
                    <h4>Node JS</h4>
                    <small className='text-light'>Basic</small>
                  </div>
                </article> */}
              </div>
              
            </div>
      </div>

    </section>
  )
}

export default Experience